// Serializes explicit transaction sections across services sharing one SQLite connection.
let txQueue = Promise.resolve();

export const withDbLock = async (callback) => {
    const execute = async () => callback();
    const run = txQueue.then(execute, execute);
    txQueue = run.catch(() => {});
    return run;
};

export default {
    withDbLock
};
